module.exports = __webpack_public_path__ + "static/media/noun-trending.d6ec1114.svg";